const SERVICE = "customer";

const address = async (api) =>
  api.setMethod().get().setService(SERVICE).process("/address");

const createAddress = async (api, body) =>
  api.setMethod().post().setService(SERVICE).setBody(body).process("/address");

const updateAddress = async (api, body) =>
  api
    .setMethod()
    .post()
    .setService(SERVICE)
    .setBody(body)
    .process("/address/update");

module.exports = {
  address,
  createAddress,
  updateAddress,
};
